import api, { API } from "@/lib/api";

const KEY = "cz_member_token";
export const getMemberToken = () => localStorage.getItem(KEY);
export const setMemberToken = (t) => localStorage.setItem(KEY, t);
export const clearMember = () => localStorage.removeItem(KEY);

const authHeaders = () => {
  const t = getMemberToken();
  return t ? { headers: { Authorization: `Bearer ${t}` } } : {};
};

export const avatarUrl = (m) =>
  m?.has_avatar ? `${API}/public/avatar/${m.id}?t=${encodeURIComponent(m.avatar_updated_at || "")}` : "";

export const memberApi = {
  me: () => api.get("/member/me", authHeaders()),
  checkEmail: (payload) => api.post("/member/otp/check", payload),
  requestOtp: (payload) => api.post("/member/otp/request", payload),
  verifyOtp: (payload) => api.post("/member/otp/verify", payload),
  enquiries: () => api.get("/member/enquiries", authHeaders()),
  enquiry: (id) => api.get(`/member/enquiries/${id}`, authHeaders()),
  toggleSaved: (payload) => api.post("/member/saved-locations", payload, authHeaders()),
  updateProfile: (payload) => api.put("/member/profile", payload, authHeaders()),
  updateCompany: (payload) => api.put("/member/company", payload, authHeaders()),
  updateEmergency: (payload) => api.put("/member/emergency", payload, authHeaders()),
  updatePreferences: (payload) => api.put("/member/preferences", payload, authHeaders()),
  communications: () => api.get("/member/communications", authHeaders()),
  communication: (id) => api.get(`/member/communications/${id}`, authHeaders()),
  membership: () => api.get("/member/membership", authHeaders()),
  uploadAvatar: (file) => {
    const fd = new FormData();
    fd.append("file", file);
    return api.post("/member/avatar", fd, authHeaders());
  },
};
